import { CustomerPageMenuItem } from 'models/CustomerPageMenuItem';
import { isCustomerPage } from 'models/CustomerPageModel';
import { PageState } from 'models/PageState';

export const selectContactUrl = (state: PageState): string => {
  const contactSection = state.header.contactSection;
  if (!contactSection) {
    return '';
  }

  return contactSection.contactUrl;
};

export const selectReturnsPageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.returnsPageUrl ?? '';
};

export const selectPaymentsPageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.paymentPageUrl ?? '';
};

export const selectChangesPageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.changesPageUrl ?? '';
};

export const selectPriceMatchPageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.priceMatchPageUrl ?? '';
};

export const selectClaimsPageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.claimsPageUrl ?? '';
};

export const selectDeliveriesPageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.deliveryPageUrl ?? '';
};

export const selectRentalPageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.rentalPageUrl ?? '';
};

export const selectShippingDamagePageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.shippingDamagePageUrl ?? '';
};

export const selectCustomerPageUrl = (state: PageState): string => {
  if (!isCustomerPage(state.currentPage)) {
    return '';
  }

  return state.currentPage.loginPage;
};

export const selectMenuItems = (state: PageState): CustomerPageMenuItem[] =>
  isCustomerPage(state.currentPage) ? state.currentPage.menuItems : [];

export const selectOrderNumber = (state: PageState): string | undefined =>
  isCustomerPage(state.currentPage) ? state.currentPage.orderNumber : undefined;

export const selectIsCustomerPage = (state: PageState): boolean =>
  isCustomerPage(state.currentPage);
